var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCircleClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.364 15.364C18.8787 11.8492 18.8787 6.15076 15.364 2.63604C11.8492 -0.87868 6.15076 -0.87868 2.63604 2.63604C-0.87868 6.15076 -0.87868 11.8492 2.63604 15.364C6.15076 18.8787 11.8492 18.8787 15.364 15.364ZM6.1073 5.52875L5.52876 6.10729L8.42147 9L5.52876 11.8927L6.1073 12.4713L9.00001 9.57854L11.8927 12.4713L12.4713 11.8927L9.57855 9L12.4713 6.10729L11.8927 5.52875L9.00001 8.42146L6.1073 5.52875Z",
    fill: "#9B9B9B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleClose);
export default __webpack_public_path__ + "static/media/ic_circle_close.dbd776d9.svg";
export { ForwardRef as ReactComponent };